// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__BdpSZ","errorLogs":"EditorFooter_errorLogs__3otFG"};